export default __webpack_public_path__ + "static/media/background_tshirt.cfc40a28.png";